<template>
  <div class="rounded-xl border border-WHITE p-3 flex flex-col gap-3 w-full">
    <div class="flex w-full items-end">
      <div class="w-3/5">
        <p class="text-sm text-left font-semibold text-white">{{ detailData.title }}</p>
      </div>
      <div class="w-2/5 flex flex-col items-end">
        <!-- TODO:: @mucahit dayjs error -->
        <p class="text-xs font-semibold text-white">{{ dayjs().format('DD MMM YYYY') }}</p>
        <p class="text-xs font-semibold text-GREY">
          {{ dayjs().subtract(1, 'hour').format('HH:mm') }}
        </p>
      </div>
    </div>
    <div class="w-full h-px bg-WHITE"></div>
    <div
      class="w-full flex items-center"
      v-if="detailData.type !== 'upgrade' && detailData.type !== 'nft-buy'"
    >
      <div class="flex items-center gap-4 w-2/3">
        <div class="h-14 w-14 rounded-md bg-LIGHT-PURPLE shrink-0"></div>
        <div class="flex flex-col gap-2">
          <p class="text-xs text-left font-semibold text-white">{{ detailData.subtitle }}</p>
          <div class="flex flex-row gap-1.5">
            <img src="../assets/icons/token-2.svg" class="h-4 object-contain" />
            <p class="text-xs text-white">{{ detailData.currency }}</p>
          </div>
        </div>
      </div>
      <div class="w-1/3 flex justify-end">
        <div
          v-if="detailData.type === 'unlock'"
          class="flex items-center gap-1.5 text-xs font-semibold"
        >
          <img src="@/assets/icons/lock.svg" class="w-4 h-4 object-contain" />
          <p class="text-xs text-white font-semibold">Unlocked</p>
        </div>
        <p v-else-if="detailData.type === 'buy'" class="text-xs text-white font-semibold">Buyed</p>
        <p v-else-if="detailData.type === 'equipped'" class="text-xs text-white font-semibold">
          Equipped
        </p>
        <p v-else-if="detailData.type === 'completed'" class="text-xs text-white font-semibold">
          Claimed
        </p>
      </div>
    </div>
    <div class="w-full flex items-center" v-if="detailData.type === 'upgrade'">
      <div class="flex items-center w-full gap-2">
        <div class="h-6 w-6 rounded-md bg-LIGHT-PURPLE shrink-0"></div>
        <div class="flex flex-col">
          <p class="text-xs text-left font-semibold text-white">{{ detailData.subtitle }}</p>
          <p class="text-xs text-left font-semibold text-GREY">Level 0</p>
        </div>
      </div>
      <font-awesome-icon size="lg" class="green-icon" :icon="['fas', 'angles-right']" />
      <div class="flex items-center gap-2 w-full justify-end">
        <div class="flex flex-col">
          <p class="text-xs text-right font-semibold text-white">{{ detailData.subtitle }}</p>
          <p class="text-xs text-right font-semibold text-GREY">Level 0</p>
        </div>
        <div class="h-6 w-6 rounded-md bg-LIGHT-PURPLE shrink-0"></div>
      </div>
    </div>
    <div class="w-full flex flex-col gap-4 items-center" v-if="detailData.type === 'nft-buy'">
      <div class="flex items-center w-full gap-2">
        <div class="h-14 w-14 rounded-md bg-LIGHT-PURPLE shrink-0"></div>
        <div class="flex flex-col">
          <p class="text-xs text-left font-semibold text-white">{{ detailData.subtitle }}</p>
          <p class="text-xs text-left font-semibold text-GREY">Created By : Ghozaly Everyday</p>
        </div>
        <p class="font-medium ml-auto text-white text-xs">Owned</p>
      </div>
      <p class="font-medium text-white text-xs">from</p>
      <div class="flex items-center gap-2 w-full">
        <div class="h-14 w-14 rounded-md bg-LIGHT-PURPLE shrink-0"></div>
        <div class="flex flex-col">
          <p class="text-xs text-left font-semibold text-white">{{ detailData.subtitle }}</p>
          <p class="text-xs text-left font-semibold text-GREY">Created By : Ghozaly Everyday</p>
        </div>
        <p class="font-medium ml-auto text-white text-xs text-nowrap">1/25 Owned</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDayjs } from '@/composables/dayjs'
const dayjs = useDayjs()

defineProps({
  detailData: {
    type: Object,
    default: () => {}
  }
})
</script>
